import bootbox from 'bootbox'
import * as base64url from '../helpers/base64url'


const meta = 'enroll'
window[`fnc_${meta}`] = initEnrollPage

document.addEventListener("loadPage", () => {
    const evMeta = document.querySelector('meta[name="eventListener"]')
    if (evMeta !== null && evMeta['content'] === meta) {
        document.addEventListener("appReady", () => {
            if (DEBUG) console.log((`Initializing ${meta} page`))
            window[`fnc_${meta}`]()
        })
    }
})


function initEnrollPage() {
    if (!window.PublicKeyCredential) {
        bootbox.alert({
            title: global.i18n.t('enroll.title'),
            message: global.i18n.t('enroll.not_supported'),
            centerVertical: true,
        })
        
        return 
    }


    const forms = document.querySelectorAll('.needs-validation')

    Array.from(forms).forEach(form => {
        form.addEventListener('submit', event => {
            // @ts-expect-error n/a
            form.checkValidity()
            form.classList.add('was-validated')

            event.preventDefault()
            event.stopPropagation()

            // @ts-expect-error n/a
            if (form.checkValidity()) {
                const params = {
                    email: $('#username').val(),
                    _csrf: $("meta[name=_csrf]").attr("content")
                }
        
                $.ajax({
                    url: '/json/send-enrollment-code',
                    method: 'POST',
                    data: params,
                    success: function (response) {
                        if (DEBUG) console.log(response)
        
                            const message = `
                                <div class="form-floating mb-3">
                                    <input type="text" name="password" class="form-control" id="password" autocomplete="off">
                                        <label for="password">${global.i18n.t('enroll.code')}</label>
                                </div>
                            `
            
                            bootbox.dialog({
                                title: global.i18n.t('enroll.title'),
                                message: message,
                                centerVertical: true,
                                buttons: {
                                    cancel: {
                                        label: global.i18n.t('buttons.cancel'),
                                        className: 'btn-light'
                                    },
                                    confirm: {
                                        label:  global.i18n.t('buttons.ok'),
                                        className: 'btn-primary',
                                        callback: function () {
                                            const password = $('#password').val()
        
                                            if (password !== '') {
                                                const params = {
                                                    username: $('#username').val(),
                                                    password: $('#password').val(),
                                                    _csrf: $("meta[name=_csrf]").attr("content")
                                                }
                                        
                                                $.ajax({
                                                    url: '/json/check-enrollment-code',
                                                    method: 'POST',
                                                    data: params,
                                                    success: function (response) {
                                                        if (DEBUG) console.log(response)
                                            
                                                        setTimeout(enroll, 10)                                         
                                                    },
                                                    error: function (err) {
                                                        helpers.alert(err)
                                                        bootbox.alert({
                                                            title: global.i18n.t('enroll.title'),
                                                            message: global.i18n.t('enroll.wrongCode'),
                                                            centerVertical: true,
                                                        })
                                                    }
                                                })
                                            } else {
                                                return false
                                            }

                                        }
                                    }
                                }
                            })
        
                    },
                    error: function (err) {
                        helpers.alert(err)
                        bootbox.alert({
                            title: global.i18n.t('enroll.title'),
                            message: global.i18n.t('enroll.userNotFound'),
                            centerVertical: true,
                        })
                    }
                })
            }
        }, false)
    })

    function enroll() {
        const message = `
            <div class="form-floating mb-3">
                <input type="text" name="keyname" class="form-control" id="keyname" autocomplete="off">
                    <label for="keyname">${global.i18n.t('enroll.webauthn.placeholder')}</label>
            </div>
        `

        bootbox.dialog({
            title: global.i18n.t('enroll.key_name'),
            message: message,
            centerVertical: true,
            buttons: {
                cancel: {
                    label: global.i18n.t('buttons.cancel'),
                    className: 'btn-light'
                },
                confirm: {
                    label:  global.i18n.t('enroll.webauthn.generate'),
                    className: 'btn-primary',
                    callback: function () {
   
                        const params = {
                            name: $('#keyname').val(),
                            username: $('#keyname').val(),
                            _csrf: $("meta[name=_csrf]").attr("content")
                        }
                
                        $.ajax({
                            url: '/webauthn/signup/public-key/challenge',
                            method: 'POST',
                            data: params,
                            success: async function (json) {  
                                if (DEBUG) console.log(json)
                
                                const credential = await navigator.credentials.create({
                                    publicKey: {
                                        rp: {
                                            id: window.location.host,
                                            name: 'myBanks'
                                        },
                                        user: {
                                            id: base64url.decode(json.user.handle),
                                            name: json.user.name,
                                            displayName: json.user.displayName
                                        },
                                        challenge: base64url.decode(json.challenge),
                                        pubKeyCredParams: [
                                            {
                                            type: 'public-key',
                                            alg: -7 // ES256
                                            },
                                            {
                                            type: 'public-key',
                                            alg: -257 // RS256
                                            }
                                        ],
                                        //attestation: 'none',
                                        authenticatorSelection: {
                                            //authenticatorAttachment: 'cross-platform', // "platform" | "cross-platform"
                                            residentKey: 'preferred', // "discouraged" | "preferred" | "required"
                                            requireResidentKey: true, // true | false (default)
                                            userVerification: 'required', // "required" | "preferred" (default) | "discouraged"
                                        },
                                        timeout: 60000
                                        //extensions: {
                                        //  credProps: true
                                        //}
                                    },
                                })
                
                                var body = {
                                    response: {
                                        clientDataJSON: base64url.encode(credential['response']['clientDataJSON']),
                                        attestationObject: base64url.encode(credential['response']['attestationObject'])
                                    }
                                }
                
                                if (credential['response']['getTransports']) {
                                    body['response']['transports'] = credential['response']['getTransports']()
                                }
                                
                                body['_csrf'] = $("meta[name=_csrf]").attr("content")
                        
                                $.ajax({
                                    url: '/webauthn/login/public-key',
                                    method: 'POST',
                                    data: JSON.stringify(body),
                                    contentType: 'application/json',
                                    success: async function (json) {  
                                        if (DEBUG) console.log(json)
                
                                            if (json['ok'])
                                                return window.location.href = json.location
                                            
                                            bootbox.alert({
                                                title: global.i18n.t('enroll.title'),
                                                message: 'INTERNAL ERROR',
                                                centerVertical: true,
                                            })
                
                                    },
                                    error: function (err) {
                                        helpers.alert(err)
                                    }
                                })
                                .catch(function(error) {
                                console.log(error)
                                })
                
                    
                            },
                            error: function (err) {
                                helpers.alert(err, global.i18n.t('enroll.title'))
                            }
                        })

                        return false

                    }
                }
            }
        })
    }

}
